import { Tab, Tabs } from "@mui/material"

type ScenarioTabsProps = {
  scenarios: string[]
  selectedScenario: string
  onChange: (newValue: string) => void
}

const ScenariosTabs = (props: ScenarioTabsProps) => {
  return (
    <Tabs
      value={props.selectedScenario}
      onChange={(_event, value) => props.onChange(value)}
      aria-label="wrapped label tabs example"
    >
      {props.scenarios.map((scenario) => (
        <Tab key={scenario} value={scenario} label={scenario} wrapped />
      ))}
    </Tabs>
  )
}

export default ScenariosTabs
